module.exports = __webpack_public_path__ + "static/media/Alignment-white.f1b97b4f.svg";